module.exports = __webpack_public_path__ + "img/quotes-lukas-meisner@2x.a96f2db6.png";